module.exports = __webpack_public_path__ + "img/PCC-logo.981f91ba.svg";